import { initImageLoaders } from '../image-loader';
import { scrollBelowFixedHeader } from '../keep-in-view';

document.addEventListener('DOMContentLoaded', () => {
  initImageLoaders();

  const bodyStyleBtn = document.querySelectorAll('.showroom-body-style');
  const stateClasses = (btn, active) => (active
    ? btn.dataset.activeClass || 'bg-primary text-white'
    : btn.dataset.inactiveClass || 'border-primary text-black border-2').split(' ');

  bodyStyleBtn.forEach(btn => {
    btn.addEventListener('click', () => {
        // Styles For Body Style Selector
        bodyStyleBtn.forEach(other => {
          const active = other === btn;
          other.classList.remove(...stateClasses(other, !active));
          other.classList.add(...stateClasses(other, active));
          other.setAttribute('aria-pressed', active);
        })

        // Filter Logic
        let selectedFilter = btn.getAttribute('data-filter');
        let itemsToHide = document.querySelectorAll(`.showroom-model-box-container .showroom-model:not([data-filter*='${selectedFilter}'])`);
        let itemsToShow = document.querySelectorAll(`.showroom-model-box-container [data-filter*='${selectedFilter}']`);

        if (selectedFilter == 'all') {
          itemsToHide = [];
          itemsToShow = document.querySelectorAll('.showroom-model-box-container [data-filter]');
        }

        itemsToHide.forEach(el => {
          el.classList.add('hidden');
          el.classList.remove('show');
        });

        itemsToShow.forEach(el => el.classList.remove('show'));
        // Force a reflow so re-adding .show restarts the animation.
        void document.body.offsetWidth;

        itemsToShow.forEach((el, index) => {
          el.classList.remove('hidden');
          el.style.setProperty('--i', index);
          el.classList.add('show');
        });

    });
  });

  /* Adding an event listener to the buttons in the body style selector. When the button is clicked, it
  will scroll to the showroom models container. */
  let bodyStyleButtons = document.querySelectorAll('.body-style-container > button')

  bodyStyleButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const container = btn.parentElement;

      if (container.hasAttribute('data-keep-in-view')) {
        scrollBelowFixedHeader(container);
        return;
      }

      window.location.href = '#showroom-models-container';
    })
  })
});
